<template>
  <div>
    <v-dialog
      v-model="showDialog"
      scrollable
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-title>Missing Requirements</v-title>
        <v-layout v-if="requirements && requirements.length > 0" row wrap>
          <v-flex xs12>
            <v-subheader>
              Your order does not have all the required information. Follow the
              links below to complete the order correctly.
            </v-subheader>
          </v-flex>

          <v-flex xs12>
            <ul>
              <li v-for="(item, index) in requirements" :key="index">
                {{ item.text }}
                <v-btn
                  small
                  color="primary"
                  @click="
                    navigate(
                      item.path,
                      item.btnText == 'EEC Form' ? item.callback : () => {}
                    )
                  "
                >
                  {{ item.btnText ? item.btnText : `Edit` }}
                </v-btn>
              </li>
            </ul>
          </v-flex>
        </v-layout>
        <v-layout v-if="archived.length > 0" row wrap>
          <v-flex xs12>
            <v-subheader>There are archived plans selected on:</v-subheader>
          </v-flex>
          <v-flex xs12>
            <ul>
              <li v-for="(item, index) in archived" :key="index">
                {{ item.text }}
                {{ JSON.stringify(item) }}
                <v-btn small color="primary" @click="navigate(item.path[0])">
                  Edit
                </v-btn>
              </li>
            </ul>
          </v-flex>
        </v-layout>
        <!-- <v-layout v-if="hasNoProducts && $route.name == 'Summary'" row wrap>
          <v-flex xs12>
            <v-subheader>Products or Hardware are required to send an order</v-subheader>
          </v-flex>
          <v-flex xs12>
            <ul>
              <li>
                Add Products or Hardware to order
                <v-btn small color="primary" @click="navigate('create-ipvoice')">Edit</v-btn>
              </li>
            </ul>
          </v-flex>
        </v-layout>-->
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn
            v-if="isQantas || !isExistingCustomer"
            color="primary"
            @click="navigate('attachments/ecc')"
          >
            ECC Form
          </v-btn>-->
          <v-btn color="primary" @click="navigate('create-ipvoice')">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { routes } from '@/routes';
import { mapState, mapGetters, createNamespacedHelpers } from 'vuex';
import {
  mapRatePlanMultiRowFields,
  mapHardwareMultiRowFields,
} from '../../store/modules/orders';
const { mapState: mapOrderState, mapMutations: mapOrderMutations } =
  createNamespacedHelpers(`orders`);
const { mapActions: mapSummaryActions, mapGetters: mapSummaryGetters } =
  createNamespacedHelpers(`orders/summary`);
const { mapActions: mapCompanyActions } =
  createNamespacedHelpers(`orders/company`);
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);

export default {
  name: 'QantasRequirements',
  data() {
    return {
      requirements: [],
      archived: [],
      isClosed: false,
      show: false,
      hasNoProducts: false,
    };
  },
  computed: {
    ...mapState(['orders']),
    ...mapState('orders', ['summary', 'company', 'rows']),
    ...mapHardwareMultiRowFields(['nbnHardwares']),
    ...mapGetters('orders', [
      'totalCost',
      'isGrenke',
      'isFinance',
      'isQantas',
      'isQuote',
      'isExistingCustomer',
      'isResidential',
    ]),
    ...mapRatePlanMultiRowFields({ ratePlans: 'rows' }),
    ...mapSummaryGetters(['emailResult']),
    ...mapFeatureFlagGetters(['allFlags']),
    checkHardwareFromApplication(){
      let vm = this;
      const report = vm.summary?.reportView;
      const internets = report?.internets || [];
      const backupHandsets = internets
        .filter(x => x.dataBackup != null)
        .map(x => x.dataBackup)
        .reduce((acc, curr) => {
          acc[curr.hardwareID] = acc[curr.hardwareID] || [];
          acc[curr.hardwareID].push(curr);
          return acc;
        }, {});
      const fromNbnHardwares = internets
        .filter(x => x.modemRequired)
        .map(x => x.contractTerm)
        .map(contractTerm =>
          vm.nbnHardwares.find(item => item.contractLength === contractTerm)
        )
        .filter(Boolean);
      return { backupHandsets, fromNbnHardwares };
    },
    inValid() {
      return (
        this.requirements.length > 0 ||
        this.archived.length > 0 ||
        this.hasNoProducts
      );
    },
    showDialog() {
      return (
        this.show ||
        (!this.isValidCustomerEmail() && this.$route.name == 'Summary')
      );
    },
  },
  methods: {
    ...mapCompanyActions(['validateACN', 'getCompany']),
    ...mapOrderMutations(['setRequiredFields']),
    ...mapSummaryActions(['resetSummary', 'validateOrderView']),

    navigate(path, callback) {
      let vm = this;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (callback) {
        callback();
      }

      vm.$router.push(Array.isArray(path) ? path[0] : path);
      vm.closeModal();
    },
    closeModal() {
      let vm = this;
      vm.show = false;
      vm.$emit('onClose', false);
    },
    isArchive(data) {
      let vm = this;
      return vm.ratePlans
        .filter((row) => row.ratePlanID == data)
        .map((x) => x.archived);
    },
    getArchivedList(data) {
      let vm = this;
      data.forEach((row) => {
        if (row.ratePlanId) row.ratePlanID = row.ratePlanId;

        row.archived =
          vm.isArchive(row.ratePlanID)[0] != undefined
            ? vm.isArchive(row.ratePlanID)[0]
            : true;
      });

      return data.filter((x) => x.archived == true);
    },
    validateRatePlans() {
      let vm = this;
      let report = vm.summary.reportView;

      if (report.churns) {
        if (vm.getArchivedList(report.churns).length > 0) {
          vm.archived.push({
            text: 'PSTN Churn',
            path: ['/create-pstn'],
          });
        }
      }

      if (report.newServices) {
        if (vm.getArchivedList(report.newServices).length > 0) {
          vm.archived.push({
            text: 'New PSTN Service',
            path: ['/create-pstn'],
          });
        }
      }

      if (report.isdn) {
        if (vm.getArchivedList(report.isdn).length > 0) {
          vm.archived.push({
            text: 'ISDN Churn',
            path: ['/create-pstn'],
          });
        }
      }

      if (report.cmcs) {
        if (vm.getArchivedList(report.cmcs).length > 0) {
          vm.archived.push({
            text: 'CMCs',
            path: ['/create-cmc'],
          });
        }
      }

      if (report.faxes) {
        if (vm.getArchivedList(report.faxes).length > 0) {
          vm.archived.push({
            text: 'Fax',
            path: ['/create-fax'],
          });
        }
      }

      if (report.iPExtensions) {
        if (vm.getArchivedList(report.iPExtensions).length > 0) {
          vm.archived.push({
            text: 'IP Voice',
            path: ['/create-ipvoice'],
          });
        }
      }

      if (report.inbounds) {
        if (vm.getArchivedList(report.inbounds).length > 0) {
          vm.archived.push({
            text: 'Inbound',
            path: ['/create-inbound'],
          });
        }
      }

      if (report.internets) {
        if (vm.getArchivedList(report.internets).length > 0) {
          vm.archived.push({
            text: 'Internet',
            path: ['/create-internet'],
          });
        }
      }

      if (report.mobiles) {
        if (vm.getArchivedList(report.mobiles).length > 0) {
          vm.archived.push({
            text: 'Mobile',
            path: ['/create-mobile'],
          });
        }
      }

      if (report.sip) {
        if (vm.getArchivedList(report.sip.sipRows).length > 0) {
          vm.archived.push({
            text: 'SIP',
            path: ['/create-sip'],
          });
        }
      }

      if (report.teams) {
        if (vm.getArchivedList(report.teams.teamsRows).length > 0) {
          vm.archived.push({
            text: 'Teams',
            path: ['/create-teams'],
          });
        }
      }
    },
    isValidCustomerEmail() {
      let vm = this;
      if (!vm.isGrenke || !vm.isFinance) return true; //no need to validate
      if (!vm.isQantas || vm.isExistingCustomer) return true; //no need to validate

      let uploads = this.$store.state.orders.uploads.rows;
      let hasEecForm = uploads.some((x) =>
        x.filename.toLowerCase().includes('eec_form')
      );

      if (hasEecForm) return true;

      if (vm.emailResult) {
        if (
          vm.emailResult &&
          (!vm.emailResult.data.valid || !vm.emailResult.data.verified)
        )
          return true;

        return (
          !hasEecForm &&
          vm.emailResult &&
          (!vm.emailResult.data.ispersonal || vm.emailResult.data.isfreemail)
        );
      } else return false;
    },
    validateOrder(isShown = false) {
      let vm = this;
      vm.requirements = [];
      vm.archived = [];
      vm.setRequiredFields([]);
      vm.validateRatePlans();
      const { backupHandsets, fromNbnHardwares } = vm.checkHardwareFromApplication;
      const hasHardwareFromApplication = Object.keys(backupHandsets).length > 0 || fromNbnHardwares.length > 0;
      const contactDetails = vm.summary?.reportView?.hardwareOrder?.contactMobile || vm.summary?.reportView?.hardwareOrder?.contactEmail;
      if (vm.summary.reportView.relocation == null) vm.checkOrderProducts();
      let path = {};
      return new Promise(async (resolve, reject) => {
        let vm = this;
        if (
          vm.hasNoProducts &&
          this.$route.name == 'Summary' &&
          !vm.isFinance
        ) {
          vm.requirements.push({
            text: 'Products or Hardware are required to send an order',
            path: vm.isResidential ? ['/create-sip'] : ['/create-ipvoice'],
          });
        }
        if (hasHardwareFromApplication && !contactDetails){
          vm.requirements.push({
            text: 'Delivery Address is required to send an order',
            path: ['/create-hardware/false'],
          });
        }
        if (vm.hasNoProducts && this.$route.name == 'Summary' && vm.isFinance) {
          vm.requirements.push({
            text: 'Hardware are required to send an order',
            path: ['/create-hardware/false'],
          });
        }
        if (!vm.isValidCustomerEmail()) {
          vm.requirements.push({
            text: 'Guarantor emails with generic names or domains (e.g. sales@ or @gmail.com) need to print, sign and attach an EEC form to complete finance application',
            path: ['/attachments/eec'],
            btnText: 'EEC Form',
            callback: () => {
              var a = document.createElement('a');
              a.href = '/downloadForms/EEC_form.pdf';
              a.setAttribute('download', 'EEC_form.pdf');
              a.click();
            },
          });
        }

        let customerDetails = vm.summary.reportView.customer;

        if (
          !customerDetails ||
          !(
            (customerDetails.salutation ||
              vm.summary.reportView.customer.salutation) &&
            customerDetails.firstName &&
            customerDetails.surname &&
            (customerDetails.phone || customerDetails.mobile) &&
            ((customerDetails.mobile && customerDetails.mobile != '') ||
              (vm.summary.reportView.customer.mobile &&
                vm.summary.reportView.customer.mobile != '')) &&
            customerDetails.email &&
            (customerDetails.jobTitle ||
              vm.summary.reportView.customer.jobTitle)
          )
        ) {
          vm.requirements.push({
            text: 'Customer details missing',
            path: ['/create-customer'],
          });
        }

        if (!vm.summary.reportView.isResidential) {
          let company = vm.summary.reportView.company;
          if (!company || !company.abn || company.abn.length == 0) {
            vm.requirements.push({
              text: 'ABN is invalid',
              path: ['/create-company'],
            });
          }
        }

        vm.validateOrderView({
          orderView: { ...vm.summary.reportView, order: vm.rows[0] },
          totalCost: vm.totalCost,
        })
          .then(() => {
            if (!vm.inValid) {
              vm.show = false;
              vm.setRequiredFields([]);
            } else {
              vm.setRequiredFields(vm.requirements);
              vm.show = isShown;
              // reject('Not a valid order');
            }
            resolve(!vm.inValid);
          })
          .catch((err) => {
            if (err.response.data.status == 400) {
              let errors = err.response.data.errors;
              for (var key in errors) {
                if (!vm.requirements.some((x) => x.path == [key][0]))
                  vm.requirements.push({
                    text: errors[key][0],
                    path: [key][0],
                  });
              }
            }
            if (vm.inValid) {
              vm.setRequiredFields(vm.requirements);
              vm.show = isShown;
            }
            resolve(!vm.inValid);
          });
      });
    },
    checkOrderProducts() {
      let vm = this;
      let summary = vm.summary.reportView;
      if (
        summary.contractedValues.length == 0 &&
        !summary.churns &&
        !summary.cmcs &&
        !summary.faxes &&
        !summary.hardware &&
        !summary.iPExtensions &&
        !summary.inbounds &&
        !summary.internets &&
        !summary.isdn &&
        !summary.mobiles &&
        !summary.newServices &&
        !summary.sip &&
        !summary.ports &&
        !summary.teams &&
        summary.installationCharges.length == 0
      )
        vm.hasNoProducts = true;
      else vm.hasNoProducts = false;
    },
  },
  mounted() {
    let vm = this;
    if (vm.rows[0].customerDetails && !vm.isResidential)
      vm.getCompany(vm.rows[0].customerDetails.companyID);
  },
};
</script>

<style scoped></style>
